<template>
  <IziPage>
    <IziGrid>
      <IziCol xl="2" />
      <IziCol xl="8">
        <ProfileUser />
      </IziCol>
      <IziCol xl="2" />
    </IziGrid>
  </IziPage>
</template>
<script lang="ts">
import Base from "../../../components/base/Base.vue";
import { Options } from "vue-class-component";
import ProfileUser from "../../../components/profileUser/ProfileUser.vue";
@Options({
  components: {
    ProfileUser
  }
})
export default class Profile extends Base {}
</script>
<style lang="scss"></style>
